<script setup lang="ts">
const t2 = useT2({
  Logout: 'Atsijungti',
})
const mobile = useMobile()
</script>

<template>
  <ButtonAction icon="right" :txt="t2('Logout')" :height="mobile ? '50' : '40'" color :submit="() => useBuyerAuthUpdate({ logout: { value: true }, widget: 'logout' })">
    <IconLogout class="_svg16" />
  </ButtonAction>
</template>
